import { React, DomeComponent } from "@lexriver/dome";
import { RequestMaker } from "../../server-queries/RequestMaker";
import { Autocomplete } from "./Autocomplete";

interface Attrs{
    sessionStorageKey?:string
    onSelectSuggestion?:(text:string, suggestion:any)=>void
}

export class AutocompleteAddress extends DomeComponent<Attrs>{
    refAutocomplete!:Autocomplete
    render(){
        return (
            <Autocomplete 
                autocompleteFunctionAsync={(text) => this.getSuggestionsAsync(text)} 
                delayMs={1000} 
                onSelectItem={(text) => this.onSelectSuggestion(text)} 
                ref={ref => this.refAutocomplete = ref} 
                placeholder="Страна, город, адрес"
                sessionStorageKey={this.attrs.sessionStorageKey}
            />
        )
    }

    protected lastSuggestions:any

    protected async getSuggestionsAsync(text:string):Promise<string[]>{
        if(text.length==0) return []
        const response = await RequestMaker.sendWebsocketJsonRequestAsync<{suggestions:{value:string}[]}>({query:'address-suggestions', params:{address:text}}, this)
        const result:string[] = []
        if(response.suggestions){
            this.lastSuggestions = response.suggestions
            //console.log('saving lastSuggestions', this.lastSuggestions)
            for(let suggestion of response.suggestions){
                result.push(suggestion.value)
            }
        }
        return result


    }

    protected onSelectSuggestion(text:string){
        if(!this.attrs.onSelectSuggestion) return
        //console.log('selecting from autocomplete:', text)
        //if(!this.refPhone || !this.refZip || !this.refFio || !this.refAddress || !this.refAddressType) throw new Error()
        for(let suggestion of this.lastSuggestions){
            if(text === suggestion.value){
                //console.log('and the suggesion is', suggestion)
                //this.refZip.setValue(suggestion.data.postal_code)
                this.attrs.onSelectSuggestion(text, suggestion)
                return
            }
        }
    }

    getValue(){
        //return this.attrs.value
        return this.refAutocomplete.getValue()
    }

    setValue(value:string){
        this.refAutocomplete.setValue(value)
    }

    focus(){
        this.refAutocomplete.focus()
    }

    disable(){
        this.refAutocomplete.disable()
    }

    enable(){
        this.refAutocomplete.enable()
    }

    async hideErrorAsync(){
        await this.refAutocomplete.hideErrorAsync()
    }

    async showErrorAsync(errorMessage:string|HTMLElement){
        await this.refAutocomplete.showErrorAsync(errorMessage)
    }




}